<template>
    <div v-if="tasks">
        <div v-if="getCheckRatingEvent">{{readRatingFromStore()}}</div>
        <div v-if="competition_status == 'started' && getCountdownStatus.count <= 0">{{finishCompetition()}}</div>

        <v-layout v-if="competition_status == 'started'" row wrap>
            <CountDownTest />
        </v-layout> 

        <v-row>   <!-- content.task_list.length -->        
            <v-col v-if="tasks" v-bind:class="[showLessonList ? 'col-9' : 'col-12', (getFullScreen == 0) ? '' : 'chapter-content--expanded', 'animated-col chapter-content']"> 

                <div class="task-nav task-nav--prev" @mouseover="tripleViewModifyLeftSide = true" @mouseleave="tripleViewModifyLeftSide = false" title="Previous" @click="nextTask(-1)"><inline-svg :src="require('@/assets/img/icons/cb-play.svg')" /></div>
                <div class="task-nav task-nav--next" @mouseover="tripleViewModifyRightSide = true" @mouseleave="tripleViewModifyRightSide = false" title="Next" @click="nextTask(1)"><inline-svg :src="require('@/assets/img/icons/cb-play.svg')" /></div>

                <v-card :class="['task-card background-transparent', (getFullScreen == 0) ? '':'task-card--expanded']">
                    <div v-if="getFullScreen == 0 && type_object == 'chapter'" class="toggle-lesson-list">
                        <v-icon @click="showLessonList = !showLessonList">more_vert</v-icon>                                              
                    </div>

                    <v-card-text v-if="getFullScreen == 0">                                          
                        <v-tabs v-if="tasks.task_list"
                            class="task-wrapper"
                            v-model="position"                            
                            center-active
                            >          
                            <div v-for="(task, index) in tasks.task_list" :key="index">
                                <v-tab @click="setDataForContent(index)" v-bind:class="['task-btn', getTaskColorStyleClass(task), getTaskStyleClass(task)]"> 
                                </v-tab>
                            </div>                            
                        </v-tabs>                                                        
                    </v-card-text>
                    <div>
                        <v-toolbar class="main-toolbar" height="auto" v-if="getWaitingForResult">
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-progress-linear style="margin-top:20px"
                                        height="10" striped indeterminate color="yellow darken-2"
                                    />
                                </v-flex>
                                <v-flex xs12>
                                    <v-layout justify-center>
                                        <small v-if="getVplProcessInfo != null">{{getVplProcessInfo}}</small>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-toolbar>
                        <v-toolbar class="main-toolbar" height="auto" v-if="!getWaitingForResult">
                            <img v-if="getFullScreen != 0" :src="require('@/assets/priscilla-logo-letter'+logoThemeVersion+'.svg')" alt="letter logo" class="pa-1 ml-2 mr-4"> 
                            <template>
                                <div class="icon-wrapper" title="View switch" @click="$store.commit('setEnviroViewNo')"><inline-svg class="own-icon" :src="require('@/assets/img/icons/cb-grid.svg')" /></div>
                                <div class="icon-wrapper" title="Full screen" @click="$store.commit('setFullScreen', (getFullScreen+1) % 2, showLessonList = false)">
                                    <inline-svg v-if="getFullScreen == 0" class="own-icon" :src="require('@/assets/img/icons/cb-fullscreen.svg')" />
                                    <inline-svg v-if="getFullScreen != 0" class="own-icon" :src="require('@/assets/img/icons/cb-fullscreen-exit.svg')" />
                                </div>
                                <v-icon class="function-icons">more_vert</v-icon>
                            </template>
                            <template v-if="qtype < 8">
                                <div v-if="qtype!=1" class="icon-wrapper" title="Reset task" @click="resetTask()"><inline-svg class="own-icon" :src="require('@/assets/img/icons/cb-refresh.svg')" /></div>
                            </template>

                            <template v-if="qtype > 7">
                                <div class="icon-wrapper" title="Load default code" @click="getOriginalSource()"><inline-svg class="own-icon" :src="require('@/assets/img/icons/cb-reset.svg')" /></div>
                                <div class="icon-wrapper" title="Save code" @click="saveCode()"><inline-svg class="own-icon" :src="require('@/assets/img/icons/cb-upload.svg')" /></div>
                            </template>

                            <v-spacer></v-spacer>
                            <div v-if="type_object!='chapter'" class="score-preview-box">
                                {{user.surname}} {{user.name}}
                            </div>
                            <v-spacer></v-spacer>
                            <div class="icon-wrapper" title="Report bug" @click="$store.commit('setShowErrorMessage', !$store.getters.getShowErrorMessage)">
                                <v-icon class="own-icon" large color="primary">error</v-icon>                                        
                            </div>

                            <v-icon class="function-icons">more_vert</v-icon>
                            <template v-if="tasks.task_list[position].max_score >0">                                
                                <div class="score-preview-box" outlined>
                                    {{tasks.task_list[position].score}}/{{tasks.task_list[position].max_score}}
                                    <v-rating v-if="rating == -1"
                                        v-model="qContent.rating"                                        
                                        color="yellow darken-3"
                                        background-color=#eee
                                        empty-icon="$vuetify.icons.ratingEmpty"
                                        half-increments   
                                        dense
                                        size = 20
                                        readonly
                                    />
                                    <v-rating v-if="rating>-1"
                                        v-model="rating"
                                        color="black"
                                        background-color="yellow darken-3"
                                        empty-icon="$vuetify.icons.ratingEmpty"
                                        half-increments   
                                        dense
                                        size = 30
                                        readonly
                                    />
                                </div>  
                                <div v-if="type_object=='chapter'">
                                    <div class="icon-wrapper" title="Buy/show help" @click="tryShowHelp()">
                                        <v-icon class="own-icon" large color="primary" v-if = "!tasks.task_list[position].help_showed" >help</v-icon>
                                        <v-icon class="own-icon" large color="primary" v-if = "tasks.task_list[position].help_showed" >device_unknown</v-icon>
    <!--                                     <inline-svg v-if = "tasks.task_list[position].help_showed" class="own-icon" :src="require('@/assets/img/icons/cb-key.svg')" />                                
    -->                                </div>
                                    <div class="icon-wrapper" title="Buy/show answer" @click="tryUnlock()">
                                        <v-icon class="own-icon" large color="primary" v-if = "!tasks.task_list[position].answer_showed" >lock</v-icon>
                                        <inline-svg v-if = "tasks.task_list[position].answer_showed" class="own-icon" :src="require('@/assets/img/icons/cb-unlock.svg')" />                                        
                                    </div>
                                </div> 
                                <v-icon class="function-icons">more_vert</v-icon>
                            </template>

                            <template>                                
                                <div v-if="qtype == 8 || qtype == 9 || qtype == 10" class="icon-wrapper" title="Run code" @click="$store.commit('setRunCode',2)"><v-icon large class="own-icon material-icons-outlined">play_arrow</v-icon></div>
                                <div v-if="qtype > 7 && qtype<12" class="icon-wrapper" title="Evaluate code" @click="checkAnswer()"><inline-svg class="own-icon" :src="require('@/assets/img/icons/cb-confirm.svg')" /></div>
                                <div v-if="qtype > 12 && qtype <= 16" class="icon-wrapper" title="Check answer" @click="checkAnswer()"><inline-svg class="own-icon" :src="require('@/assets/img/icons/cb-confirm.svg')" /></div>
                            </template>
                            
                            <div v-if="(qtype>1 && qtype<8)" class="icon-wrapper" title="Check answer" @click="checkAnswer()"><inline-svg class="own-icon" :src="require('@/assets/img/icons/cb-confirm.svg')" /></div>
                        </v-toolbar>
                        <div v-if="getShowErrorMessage">           
                            <ErrorMessage v-bind:task_id='qContent.task_id' />
                        </div>   
                        
                    </div>                    
                    <v-card-text class="question-content">
                        <JptrCore v-if="qtype>11 && qtype<16"/>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <div v-if="qContent && tasks.task_list.length == 0">
                                    <v-layout row wrap justify-center>   
                                        <v-icon color="primary" x-large>block</v-icon>    
                                    </v-layout>
                                </div>

                                <div v-if="qContent && tasks.task_list.length > 0">
                                    <!-- <v-layout row wrap :key="refreshKey" class="question-wrapper">  -->
                                    <v-layout row wrap :key="refreshKey" :class="['question-wrapper', (getFullScreen != 0) ? 'ma-4':'', (tripleViewModifyLeftSide && getFullScreen != 0) ? 'pl-16':'', (tripleViewModifyRightSide && getFullScreen != 0) ? 'pr-16':'']">
                                        <AContent v-if="qtype == 1" v-bind:dcontent='qContent' v-bind:taskIndex='position' v-bind:activity_type='type_object'/> 
                                        <AType2 v-if="qtype == 2" v-bind:dcontent='qContent' v-bind:taskIndex='position' v-bind:activity_type='type_object'/> 
                                        <AType3 v-if="qtype == 3" v-bind:dcontent='qContent' v-bind:taskIndex='position' v-bind:activity_type='type_object'/> 
                                        <AType4 v-if="qtype == 4" v-bind:dcontent='qContent' v-bind:taskIndex='position' v-bind:activity_type='type_object'/> 
                                        <AType5 v-if="qtype == 5" v-bind:dcontent='qContent' v-bind:taskIndex='position' v-bind:activity_type='type_object'/> 
                                        <AType6 v-if="qtype == 6" v-bind:dcontent='qContent' v-bind:taskIndex='position' v-bind:activity_type='type_object'/> 
                                        <AType7 v-if="qtype == 7" v-bind:dcontent='qContent' v-bind:taskIndex='position' v-bind:activity_type='type_object'/> 
                                        <AType8 v-if="qtype == 8 || qtype == 9 || qtype == 10" v-bind:dcontent='qContent' v-bind:taskIndex='position' v-bind:activity_type='type_object' />                            
                                        <AType11 v-if="qtype == 11" v-bind:dcontent='qContent' v-bind:taskIndex='position' v-bind:activity_type='type_object' />
                                        <XContent v-if="qtype == 12" v-bind:dcontent='qContent' v-bind:taskIndex='position' v-bind:activity_type='type_object' />
                                        <XType13 v-if="qtype == 13" v-bind:dcontent='qContent' v-bind:taskIndex='position' v-bind:activity_type='type_object' />
                                        <XType14 v-if="qtype == 14" v-bind:dcontent='qContent' v-bind:taskIndex='position' v-bind:activity_type='type_object' />
                                        <XType15 v-if="qtype == 15" v-bind:dcontent='qContent' v-bind:taskIndex='position' v-bind:activity_type='type_object' />
                                        <XType16 v-if="qtype == 16" v-bind:dcontent='qContent' v-bind:taskIndex='position' v-bind:activity_type='type_object' />
                                        <div class="content-action-bar">
                                            
                                            <!-- <img title="Next" @click="nextTask(1)" class="own-icon right-side-of-bar" src="@/assets/img/icons/next-b&w.svg">
                                                --><img title="Check answer" v-if="qtype!=1 && qtype!=12" @click="checkAnswer()" class="own-icon right-side-of-bar" src="@/assets/img/icons/confirm-b&w.svg">
                                        </div>
                                    </v-layout>
                                </div>

                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>

            </v-col>   
            <v-col v-bind:class="[showLessonList ? 'col-3' : 'faded-col', 'animated-col course-sidebar']">
                <v-layout row wrap>                    
                    <v-flex xs12 v-if="showLessonList">
                        <v-card class="chapter-card border-radius-md shadow-none card-border-style">
                            <v-card-title>
                                {{lessons.chapter.name}}
                                <v-icon 
                                    class="btn-close"
                                    @click="showLessonList = false"
                                    >
                                close</v-icon> 

                            </v-card-title>
                            <v-card-text>
                                <v-list shaped>
                                    <v-list-item-group v-model="lessonIndex" mandatory>
                                    <v-list-item
                                        v-for="(lesson,index) in lessons.lesson_list"
                                        :key="index"
                                        @click="getLesson(index, false, 0)"
                                        >
                                        <v-list-item-icon>
                                            <v-icon v-if="(lesson.tasks_nonfinished == 0) && (lesson.programs_nonfinished == 0)"> emoji_emotions</v-icon>
                                            <v-icon v-if="(lesson.tasks_nonfinished > 0) || (lesson.programs_nonfinished > 0)"> panorama_fish_eye</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                            {{ lesson.lesson_name }}
                                            </v-list-item-title>
                                        </v-list-item-content>

                                    </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </v-card-text>
                        </v-card>
                    </v-flex>            
                </v-layout>
            </v-col>
        </v-row>

        <v-layout>
            <v-row justify="center">
                <v-dialog content-class="modal card-border-style border-radius-md" v-model="dialogHelp.show" persistent max-width="290"> 
                        <v-card class="background-transparent shadow-none">
                            <v-card-title class="headline">{{dialogHelp.title}}</v-card-title>
                            <v-card-text v-html="dialogHelp.text"> 
                            </v-card-text>
                            <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" text @click="dialogHelp.show = false">Cancel</v-btn>
                            <v-btn color="primary" text @click="buyAnything()">OK</v-btn>
                            </v-card-actions>
                        </v-card>                   
                </v-dialog>
            </v-row>
        </v-layout>

    </div>
</template>

<script>
import axios from '../../axios-auth.js'
import {mapGetters} from 'vuex'
import AContent from '../tasks/AContent.vue'
import AType2 from '../tasks/AType2.vue'
import AType3 from '../tasks/AType3.vue'
import AType4 from '../tasks/AType4.vue'
import AType5 from '../tasks/AType5.vue'
import AType6 from '../tasks/AType6.vue'
import AType7 from '../tasks/AType7.vue'
import AType8 from '../tasks/AType8.vue'
import AType11 from '../tasks/AType11.vue'
import XContent from '../tasks/XContent.vue'
import XType13 from '../tasks/XType13.vue'
import XType14 from '../tasks/XType14.vue'
import XType15 from '../tasks/XType15.vue'
import XType16 from '../tasks/XType16.vue'
import CountDownTest from '../../components/misc/CountDownTest.vue'
import JptrCore from '../../components/jprcomponents/jptr_core.vue'
import ErrorMessage from '../../components/misc/ErrorMessage.vue'

export default {
    data() {
        return {
            lessons: null,
            tasks: null,
            qtype : 0,
            qContent: null,
            refreshKey : 0,
            position: 0,
            lessonIndex: -1,
            item : 2,
            dialogHelp : {
                show: false,
                title: '',
                text: '',
                type: ''
            },
            rating: -1,
            course_id: null,
            chapter_id: null,
            showLessonList: false, 
            // type_object : 'chapter',
            logoThemeVersion: '',
            tripleViewModifyLeftSide: false,
            tripleViewModifyRightSide: false,     
            competition_status:''       
        }
    },
    props : ['type_object'],
    components: {
        AContent,
        AType2,
        AType3,
        AType4,
        AType5,
        AType6,
        AType7,
        AType8,
        AType11,
        XContent,
        XType13,
        XType14,
        XType15,
        XType16,
        CountDownTest,
        JptrCore,
        ErrorMessage
    },
    computed: 
        mapGetters([
                    'getCheckRatingEvent',
                    'getTransferAnswer',
                    'getUserPerformance',
                    'getCountdownStatus',
                    'getFullScreen',
                    'getWaitingForResult',
                    'getVplProcessInfo',
                    'isLogged',
                    'getThemePreference',
                    'getShowErrorMessage',
                    'user'
                ])
    ,
    watch: {
      getThemePreference: function() {
        this.changeThemeLogo();
      },
      isLogged: function() {
        this.changeThemeLogo();
      }
    },
    mounted() {
        this.initData()
    },
    created() {
      this.changeThemeLogo()
    },
    methods : {
        refreshChildComponent() {
            this.refreshKey += 1
        },

        // **************************************
        /// read data from server
        // **************************************
        initData() {
            this.$store.commit('setFeedback', null)     
            if (this.type_object == "chapter") this.initChapterData()
            if (this.type_object == "competition") this.initCompetitionData()
        },
        initChapterData() {
            axios.get('/get-active-lessons2/' + this.$route.params.id, this.$store.getters.getAxiosConfig)
                .then(res => {
                    this.lessons = res.data                     
                    this.course_id = res.data.course.id
                    this.chapter_id = res.data.chapter.id
                    const bc = [
                        { text: res.data.category.name, href: '/areas/' + res.data.category.id },//#
                        { text: res.data.area.name, href: '/courses/' + res.data.area.id }, //#                   
                        { text: res.data.course.name, href: '/course_content/' + res.data.course.id },//#                    
                        { text: res.data.chapter.name, href: '/chapter_content/' + res.data.chapter.id },//#                    
                    ]
                    this.$store.commit('setBreadCrumbs',bc)   

                    this.course_id = res.data.course.id
                    this.getCourseInfo()
                    this.findNonFinishedLesson()
                    this.getLesson(this.lessonIndex, true, 2)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
        },
        initCompetitionData() {
            axios.get('/get-my-competition/' + this.$route.params.id, this.$store.getters.getAxiosConfig)
                .then(res => {
                    this.lessons = res.data 
                    this.course_id = res.data.course.id
                    this.competition_id = res.data.competition.id
                    this.competition_name = res.data.competition.name

                    const bc = [
                        { text: res.data.category.name, href: '/areas/' + res.data.category.id },//#
                        { text: res.data.area.name, href: '/courses/' + res.data.area.id }, //#                   
                        { text: res.data.course.name, href: '/course_content/' + res.data.course.id },//#                    
                        { text: res.data.competition.name, href: '/competition_content/' + res.data.competition.id },//#                    
                    ]
                    this.$store.commit('setBreadCrumbs',bc)   

                    this.getCourseInfo()
                    this.getCompetitionLessons()
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
        },
        getCourseInfo() {
            axios.get('/get-vpl-course-info/' + this.course_id, this.$store.getters.getAxiosConfig )
                .then((res) => {
                    this.$store.commit('setEditorType',res.data.editorType)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })                
        },
        getLesson(index, _autosearch, _first_last) {
            if (this.type_object == "chapter") this.getChapterLesson(index, _autosearch, _first_last)
            if (this.type_object == "competition") this.getCompetitionLessons()
        },
        getChapterLesson(index, _autosearch, _first_last) {
            this.lessonIndex = index
            axios.get('/get-active-tasks2/' 
                      + this.course_id + '/'+
                      + this.chapter_id + '/'+
                      + this.lessons.lesson_list[index].lesson_id
                      , this.$store.getters.getAxiosConfig)
                .then(res => {
                    this.tasks = res.data
                    if (_autosearch) {
                        let index = this.getNonFinishedTaskIndex()
                        if (index > -1) {
                            this.setDataForContent(index)
                        } else {
                            this.qContent = null
                        }
                    } else {
                        if (_first_last==0) this.setDataForContent(0)
                        if (_first_last==1) this.setDataForContent(this.tasks.task_list.length-1)
                    }
                    this.showLessonList = false
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })           
        },
        getCompetitionLessons() {
            axios.get('/get-active-competition/' 
                      + this.course_id + '/'+
                      + this.$route.params.id 
                      , this.$store.getters.getAxiosConfig)
                .then((res) => {
                    this.tasks = res.data
                    this.competition_status = res.data.status
                    if (this.competition_status == 'started') {
                        this.$store.commit('setCountdownStatus', 
                            {id: this.$route.params.id, count: this.tasks.time_limit - this.tasks.spent_time, 
                             max: this.tasks.time_limit, synchro_type: 'competition'} )
                        this.setDataForContent(0)
                    } 
                    if (this.competition_status == 'finished') this.$router.push({name:'competition_result', params: {id: this.$route.params.id}})
                    
                    
                   /*  else {
                        this.tasks.teacher_score = 0
                        for(let i = 0; i< this.tasks.task_list.length; i++)
                          this.tasks.teacher_score = this.tasks.teacher_score + this.tasks.task_list[i].teacher_score
                    } */
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })           
        },        
        finishCompetition() {
            this.competition_status = ''
            axios.get('/close-competition/' + this.$route.params.id, this.$store.getters.getAxiosConfig )
            .then( () => {
                this.$router.push({name:'competition_result', params: {id: this.$route.params.id}})
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })                
        },
        //******************************************** */
        //* data manipulation
        //******************************************** */
        setDataForContent(index) {            
            if (this.tasks == null) return
            
            if (this.type_object == 'chapter') { // can go out of lessons
                if (index == this.tasks.task_list.length) { // end of lesson
                    if (this.lessonIndex < this.lessons.lesson_list.length-1) {
                        this.getLesson(this.lessonIndex + 1, false, 0)
                    } else {
                        this.$store.commit('setFullScreen',false)
                        this.$router.push({name:'course_content', params: {id: this.course_id}})  
                    }
                    return 
                }

                if (index == -1) { // begin of lesson
                    if (this.lessonIndex > 0) {
                        this.getLesson(this.lessonIndex - 1, false, 1)
                    } else {
                        this.$store.commit('setFullScreen',false)
                        this.$router.push({name:'course_content', params: {id: this.course_id}})  
                    }
                    return 
                }            
            }

            if (this.type_object == 'competition') { // can't go out of lessons
                if (index < 0) index = 0
                if (index >= this.tasks.task_list.length) index = this.tasks.task_list.length - 1
            }

            if (index < this.tasks.task_list.length) {
                this.refreshChildComponent()
                this.position = index

                this.qtype = this.tasks.task_list[index].task_type_id
                var c = null
                var g = null
                switch (this.qtype) {
                    case 1:
                        c = this.tasks.task_list[index].content
                        break;
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                        c = JSON.parse(this.tasks.task_list[index].content)
                        g = this.tasks.task_list[index].globals
                        break;
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                        c = JSON.parse(this.tasks.task_list[index].content)
                        g = JSON.parse(this.tasks.task_list[index].globals)
                        break;
                    case 12:
                        c = JSON.parse(this.tasks.task_list[index].content)
                        break
                    case 13:
                    case 14:
                    case 15:
                    case 16:
                        // console.log(this.tasks.task_list[index].content)
                        c = JSON.parse(this.tasks.task_list[index].content)
                        // g = this.tasks.task_list[index].globals
                        
                        break;
                }
                
                const _score = Math.floor(0.5 + 100*this.tasks.task_list[index].score/this.tasks.task_list[index].max_score)
                this.qContent = { data: {
                                        content: c,
                                        globals: g
                                    },
                                    task_id: this.tasks.task_list[index].task_id,
                                    task_type_id: this.tasks.task_list[index].task_type_id,
                                    user_course_id: this.tasks.user_course_id,
                                    course_id: this.course_id,
                                    chapter_comp_id: this.chapter_id,
                                    score : _score,
                                    rating: _score / 20,
                                    passed : this.tasks.task_list[index].passed
                                }
            }
        },
        findNonFinishedLesson() {            
            for(let i = 0; i < this.lessons.lesson_list.length; i++) {
                if ((this.lessons.lesson_list[i].tasks_nonfinished > 0) || (this.lessons.lesson_list[i].programs_nonfinished > 0)) {
                    this.lessonIndex = i
                    return
                }
            }
            this.lessonIndex = 0 //this.lessons.lesson_list.length - 1
        },
        getNonFinishedTaskIndex() {
            for(let i = 0; i < this.tasks.task_list.length; i++) {
               if (!this.tasks.task_list[i].passed) return i
               if (this.tasks.task_list[i].score < this.tasks.task_list[i].max_score / 2) {
                   if (i > 0) { // set to content before question
                      if (this.tasks.task_list[i].task_type_id > 1 && this.tasks.task_list[i-1].task_type_id == 1) {
                          return i - 1
                      } else {
                          return i
                      }
                   } else {
                       return i
                   }
               }
            }
            // all content was passed
            if (this.tasks.task_list.length > 0) return 0
            else return -1 // not any content
        },

        //******************************************* */
        // redraw content - styles
        //******************************************* */
        nextTask(_change) {
            this.setDataForContent(this.position+_change)
        },
        checkAnswer() { // start checking answer
            this.$store.commit('setWaitingForResult',true) 
            this.$store.commit('setCheckAnswerEvent',true)            
        },
        readRatingFromStore() {            
            this.$store.commit('setCheckRatingEvent',false)
            //this.$store.commit('setWaitingForResult',false) 
            const _currentScore = Math.floor(this.getTransferAnswer.rating/100 * this.tasks.task_list[this.getTransferAnswer.index].max_score +0.5)

            this.startTimer(Math.floor(this.getTransferAnswer.rating+0.5)/20)
            if (this.getTransferAnswer.rating >=50 ) this.tasks.task_list[this.getTransferAnswer.index].passed = true   

            // content
            this.tasks.task_list[this.getTransferAnswer.index].first_time = false
            if (this.tasks.task_list[this.getTransferAnswer.index].task_type_id == 1 || this.tasks.task_list[this.getTransferAnswer.index].task_type_id == 12) {
                this.tasks.task_list[this.getTransferAnswer.index].passed = true
                const data = {
                    user_course_id : this.lessons.user_course_id,
                    task_id : this.tasks.task_list[this.getTransferAnswer.index].task_id
                }
                axios.post('/set-passed-tasks-content2', data, this.$store.getters.getAxiosConfig)
                    .then(() => {
                    })
                    .catch(error => {
                        this.$store.commit('setFeedback', error)
                    })   
                return
            } else {
            // tasks            
                if (this.tasks.task_list[this.getTransferAnswer.index].answer_showed) {
                    this.tasks.task_list[this.getTransferAnswer.index].passed = true
                    return
                }
                if (_currentScore > this.tasks.task_list[this.getTransferAnswer.index].score)
                    this.tasks.task_list[this.getTransferAnswer.index].score =  _currentScore            
                if (this.getTransferAnswer.rating >=50 ) this.tasks.task_list[this.getTransferAnswer.index].passed = true   
            }
        },
        startTimer(_currentScore) {   
            var timer
            if (_currentScore > 0) {                
                this.rating = 0
                timer = setInterval(() => { if(this.rating >= _currentScore-0.1) { // psycho
                                                    clearInterval(timer); 
                                                    timer = null
                                                    this.finishTimer()
                                                } else {
                                                    this.rating += 0.5
                                                    }
                                                }, 50);
            } else {
                this.rating = 5
                timer = setInterval(() => { if(this.rating == 0) {
                                                    clearInterval(timer); 
                                                    timer = null
                                                    this.finishTimer()
                                                } else {
                                                    this.rating -= 0.5
                                                }
                                                }, 50);                                                
            }            
        },    
        finishTimer() {
            let t2 = setInterval(() => {if (this.qContent.rating <= this.rating) this.qContent.rating = this.rating
                                        this.rating = -1
                                        clearInterval(t2)
                                        t2 = null}, 500);
        },    

        tryUnlock() {
            this.dialogHelp.type = 'answer'            
            if (!this.tasks.task_list[this.position].answer_showed) {
                if (this.tasks.task_list[this.position].max_score * 2 > this.getUserPerformance.coins) {
                    this.$store.commit('setFeedback', 'Not enough coins for this operation.')
                    return
                }
                this.dialogHelp.title = 'Do you want an answer?'
                this.dialogHelp.text = '<p>Are you sure? The answer costs <b>' + this.tasks.task_list[this.position].max_score * 2 +' coins</b>.</p>'                           
                this.dialogHelp.show = true
            } else this.buyAnything()
        },
        tryShowHelp() {
            this.dialogHelp.type = 'help'
            if (!this.tasks.task_list[this.position].help_showed) {
                if (this.tasks.task_list[this.position].max_score > this.getUserPerformance.coins) {
                    this.$store.commit('setFeedback', 'Not enough coins for this operation.')
                    return
                }
                this.dialogHelp.title = 'Do you want a help?'
                this.dialogHelp.text = '<p>Are you sure?</p> <p>The help costs <b>' + this.tasks.task_list[this.position].max_score +' coins</b>.</p>'            
                this.dialogHelp.show = true
            } else this.buyAnything()
        },
        buyAnything() {
            this.dialogHelp.show = false
            if (this.dialogHelp.type == 'answer') {
                this.$store.commit('setShowAnswerEvent',true)
                this.tasks.task_list[this.position].answer_showed = true
                this.tasks.task_list[this.position].passed = true
            } else {
                // fill the help it returns only help or sorry no help
                axios.get('/get-my-help/'+this.tasks.task_list[this.position].task_id, this.$store.getters.getAxiosConfig)
                    .then((res) => {
                        //*************************************** */
                        this.tasks.task_list[this.position].help = res.data.help                        
                        this.tasks.task_list[this.position].help_showed = true
                        this.$store.commit('setUserPerformance',res.data.user)
                        // help or info about no help
                        this.$store.commit('setShowModalMessage',{content: res.data.help, type: 'info', 
                                            buttons:[{text:'OK', value: 1}], icons:[]})
                    })
                    .catch(error => {
                        this.$store.commit('setFeedback', error)
                    })                                    
            }
        },
        getTaskStyleClass(task) {
            if (task.passed && ((task.task_type_id == 1 || task.task_type_id == 12))) return 'passed-task-style'
            if (task.first_time) return 'blank-task-style'
            if (task.passed && task.task_type_id != 1 && task.task_type_id != 12 && task.score == task.max_score) return 'passed-task-style'
            if (task.score >= task.max_score/2) return 'half-completed-task-style'
            return 'failed-task-style'
        },
        getTaskColorStyleClass(task) {
          if (task.task_type_id == 1 || task.task_type_id == 12) return 'reading-task'
          if (task.task_type_id > 1 && task.task_type_id < 8) return 'question-task'
          if (task.task_type_id > 7 && task.task_type_id < 12) return 'program-task'
          if (task.task_type_id > 11 && task.task_type_id < 16) return 'question-task'
        },
        saveCode() {
            this.$store.commit('setSaveCode', true)
        },
        resetTask() {
            this.setDataForContent(this.position)
        },
        getOriginalSource() {
            this.$store.commit('setResetTask',true) // READ ORIGINAL CODE
        },
        changeThemeLogo() {
            if(this.isLogged == true) {
                if(this.getThemePreference == 'os-preference') {
                    const prefersDarkScheme = window.matchMedia("(prefers-color-scheme: dark)");
                    if (prefersDarkScheme.matches) {
                    this.logoThemeVersion = "-w"; 
                    } else {
                    this.logoThemeVersion = ""; 
                    }
                    // pokial je zvolena OS preferencia - kontrolujeme ci pocas behu nebola zmenena téma
                    window.matchMedia('(prefers-color-scheme: dark)')
                    .addEventListener('change', event => {
                    if (event.matches) {
                        this.logoThemeVersion = "-w"; 
                    } else {
                        this.logoThemeVersion = ""; 
                    }
                    })
                } else if(this.getThemePreference == 'dark') {
                    this.logoThemeVersion = "-w"; 
                } else if(this.getThemePreference == 'light' || this.getThemePreference == 'colorblind') {
                    this.logoThemeVersion = ""; 
                }
            } else {
                this.logoThemeVersion = ""; 
            }
        }
    }
}

</script>

<style>

</style>